import { useTranslation } from 'react-i18next';
import NewDescription from '../../../new/NewDescription';

export const PositionDescription = ({
  label,
  data,
  moduleKey,
  onChange,
  showVars,
  descriptionVars,
  imageType,
  imageApiFilter,
  textBlockType,
}) => {
  const { t } = useTranslation();

  return (
    <NewDescription
      label={t(label)}
      onSave={onChange}
      startHTML={data}
      className="col-span-2 md:col-span-3 max-h-[60px]"
      descriptionVars={descriptionVars}
      showVars={showVars}
      imageType={imageType}
      imageApiFilter={imageApiFilter}
      textBlockType={textBlockType}
    />
  );
};
